const WHO_TYPE = {
	ME: { label: 'Just me', value: 'ME' },
	ME_AND_SPOUSE: { label: 'Me and spouse', value: 'ME_AND_SPOUSE' },
	FAMILY: { label: 'My whole family', value: 'FAMILY' },
	KIDS: { label: 'Just my kids', value: 'KIDS' },
};

const DURATION_TYPE = {
	YEAR: { value: 'YEAR', label: 'Annual' },
	MONTH: { value: 'MONTH', label: 'Month' },
	WEEK: { value: 'WEEK', label: 'Week' },
	DAY: { value: 'DAY', label: 'Day' },
	MANUAL: { value: 'MANUAL', label: 'Specific Dates' },
};

// matches PAYMENT_GATEWAYS in buddy-api's FreakonomicsInterface (ion-helpers' copy only has STRIPE)
const PAYMENT_GATEWAY = {
	STRIPE: 'STRIPE',
	STRIPE_V2: 'STRIPE_V2',
};

const PAYMENT_TYPE = {
	MONTHLY: { label: 'Monthly', value: 'MONTHLY' },
	SINGLE: { label: 'One-time', value: 'SINGLE' },
	MONTHLY_ONE_UP_FRONT: { label: 'Monthly (one month down payment)', value: 'MONTHLY_ONE_UP_FRONT' },
	MONTHLY_TWO_UP_FRONT: { label: 'Monthly (two month down payment', value: 'MONTHLY_TWO_UP_FRONT' },
	QUARTERLY: { label: 'Quarterly', value: 'QUARTERLY' },
};

const COVERED_TYPE = {
	ME: 'ME',
	SPOUSE: 'SPOUSE',
	KID: 'KID',
};

const LOG_TYPE = {
	CANCELLATION: 'CANCELLATION',
	CREATION: 'CREATION',
	ENDORSEMENT: 'ENDORSEMENT',
	INTERNAL_UPDATE: 'INTERNAL_UPDATE',
	EXPIRATION: 'EXPIRATION',
	PAYMENT_UPDATE: 'PAYMENT_UPDATE',
	MANUAL_PAYMENT: 'MANUAL_PAYMENT',
	PAYMENT: 'PAYMENT',
	PAYMENT_ERROR: 'PAYMENT_ERROR',
	PAYMENT_FAILED: 'PAYMENT_FAILED',
	PAYMENT_PENDING: 'PAYMENT_PENDING',
	PAYMENT_DISPUTE: 'PAYMENT_DISPUTE',
	PAYMENT_REFUND: 'PAYMENT_REFUND',
	PAYMENT_REFUND_FAILED: 'PAYMENT_REFUND_FAILED',
};

// These are all things payment (including updates)
const PAYMENT_LOG_TYPE = {
	[LOG_TYPE.PAYMENT]: LOG_TYPE.PAYMENT,
	[LOG_TYPE.MANUAL_PAYMENT]: LOG_TYPE.MANUAL_PAYMENT,
	[LOG_TYPE.PAYMENT_UPDATE]: LOG_TYPE.PAYMENT_UPDATE,
	[LOG_TYPE.PAYMENT_FAILED]: LOG_TYPE.PAYMENT_FAILED,
	[LOG_TYPE.PAYMENT_ERROR]: LOG_TYPE.PAYMENT_ERROR,
	[LOG_TYPE.PAYMENT_PENDING]: LOG_TYPE.PAYMENT_PENDING,
	[LOG_TYPE.PAYMENT_DISPUTE]: LOG_TYPE.PAYMENT_DISPUTE,
	[LOG_TYPE.PAYMENT_REFUND]: LOG_TYPE.PAYMENT_REFUND,
	[LOG_TYPE.PAYMENT_REFUND_FAILED]: LOG_TYPE.PAYMENT_REFUND_FAILED,
};

// Use this for ledger/transaction displays. These are things relevant to transactions.
const TRANSACTION_LOG_TYPE = {
	[LOG_TYPE.PAYMENT]: LOG_TYPE.PAYMENT,
	[LOG_TYPE.MANUAL_PAYMENT]: LOG_TYPE.MANUAL_PAYMENT,
	[LOG_TYPE.PAYMENT_FAILED]: LOG_TYPE.PAYMENT_FAILED,
	[LOG_TYPE.PAYMENT_ERROR]: LOG_TYPE.PAYMENT_ERROR,
	[LOG_TYPE.PAYMENT_PENDING]: LOG_TYPE.PAYMENT_PENDING,
	[LOG_TYPE.PAYMENT_DISPUTE]: LOG_TYPE.PAYMENT_DISPUTE,
	[LOG_TYPE.PAYMENT_REFUND]: LOG_TYPE.PAYMENT_REFUND,
	[LOG_TYPE.PAYMENT_REFUND_FAILED]: LOG_TYPE.PAYMENT_REFUND_FAILED,
};

const DATE_FORMAT = 'MM/DD/YYYY';

const STATE_REQUIRED_VALUES = {
	TN: {
		paymentOption: PAYMENT_TYPE.SINGLE?.value,
	},
};

const APPROVED_STATES = [
	'AL',
	'AK',
	'AR',
	'AZ',
	'CO',
	'CT',
	'DC',
	'DE',
	'FL',
	'GA',
	'HI',
	'IA',
	'IL',
	'IN',
	'KS',
	'KY',
	'LA',
	'ME',
	'MI',
	'MO',
	'MS',
	'MT',
	'NC',
	'ND',
	'NE',
	'NH',
	'NM',
	'NV',
	'OH',
	'OK',
	'OR',
	'PA',
	'RI',
	'SC',
	'SD',
	'TN',
	'TX',
	'UT',
	'VT',
	'WA',
	'WI',
	'WV',
	'WY',
];

const ABILITY_TO_PURCHASE = {
	CONFIRMED: 'confirmed',
	NOT_IN_APPROVED_STATE: 'not-in-approved-state',
	RESIDENCE_STATE_NOT_FOUND: 'residence-state-not-found',
};

// for downloading
const DOWNLOAD_TYPE = {
	BASE64: 'BASE64',
	BLOB: 'BLOB',
	DOWNLOAD: 'DOWNLOAD',
	FILE: 'FILE',
};

const POLICY_TYPE = {
	ACCIDENT: 'BUDDY_ACCIDENT_V2',
	ACCIDENT_V2: 'WRB_BUDDY_ODACCIDENT',
	CANCELLATION: 'WRB_BUDDY_TICKETCANCEL',
	FORGE_TICKET_CANCELLATION: 'WRB_BUDDY_TICKETCANCEL_FORGE',
	ITC: 'ITC_TICKET_CANCELLATION',
	II_AIRLOCKACCIDENT: 'II_AIRLOCKACCIDENT',
	INTERPLANETARYINSURANCE_AUTO: 'INTERPLANETARYINSURANCE_AUTO',
	AAC: 'AAC_AD_AND_D',
	GAIG_SI: 'GAIG_GAIG_SI',
	POMI_ACCIDENT: 'GAIG_POMI_ACCIDENT',
	POMI_ACCIDENT_V2: 'GAIG_POMI_ACCIDENT_V2',
	GAIG_SES: 'GAIG_GAIG_SES', // contractcoverage
	STARR_AD_AND_D: 'STARR_BUDDY_ADANDD_AAC',
	VIGILANCE_V1: 'VIGILANCE_OCCUPATIONAL_ACCIDENT',
	VIGILANCE_V2: 'WRB_VIGILANCE_OCCACCIDENT',
};

// states with special DOCs
const SPECIAL_STATES = [
	'AK',
	'AR',
	'CO',
	'DC',
	'DE',
	'IL',
	'KS',
	'KY',
	'LA',
	'MI',
	'MN',
	'MO',
	'MT',
	'NC',
	'NH',
	'OH',
	'OK',
	'OR',
	'PA',
	'SD',
	'TN',
	'UT',
	'VT',
	'WA',
	'WY',
];

const NON_STANDARD_VIGILANCE_STATES = ['AK', 'CA', 'CO', 'CT', 'DE', 'FL', 'ID', 'IL', 'ME', 'MI', 'MO', 'MT', 'NC', 'NH', 'OK', 'PA', 'SC', 'SD', 'TX', 'UT', 'WA'];

const NON_STANDARD_TICKET_STATES = ['AK', 'FL', 'GA', 'IL', 'MT', 'NV', 'NY', 'OR', 'VA', 'WA'];

// TODO: This is probably obsolete with the v4 routes, but holding on here for now. - CC - 04/04/2024
// we inject properties into the customer at this point and don't want them going back to the DB, it's just for here
const CUSTOMER_PROPS_TO_OMIT = [
	'hasFilledOutContact',
	'isCurrentlyCovered',
	'isOrWillBeCovered',
	'email',
	'isVigilanceCustomer',
	'shouldOpenSettingsAsEditable',
	'hasOnlyPomiPolicies',
	'policies',
	'claims',
	'notes',
	'files',
	'contact', // update customer sends v3 address object, so we should omit any legacy refs to contact.
];
// note: I keep email from going back to the DB to insure the email CANNOT BE UPDATED yet

const NO_INTERCOM_SUBDOMAINS = ['pomi', 'fldean', 'gaig'];

const OFFERING_LABEL_MAP = {
	[POLICY_TYPE.ACCIDENT]: 'On-demand Accident',
	[POLICY_TYPE.ACCIDENT_V2]: 'On-demand Accident',
	[POLICY_TYPE.II_AIRLOCKACCIDENT]: 'Interplanetary Airlock Accident',
	[POLICY_TYPE.INTERPLANETARYINSURANCE_AUTO]: 'Interplanetary Cosmic Cruiser',
	[POLICY_TYPE.CANCELLATION]: 'Ticket cancellation',
	[POLICY_TYPE.FORGE_TICKET_CANCELLATION]: 'Ticket cancellation',
	[POLICY_TYPE.ITC]: 'ITC Ticket cancellation',
	[POLICY_TYPE.AAC]: 'AAC Accidental Death and Dismemberment',
	[POLICY_TYPE.GAIG_SI]: 'Season Interruption Insurance',
	[POLICY_TYPE.GAIG_SES]: 'Specialty Equipment',
	[POLICY_TYPE.POMI_ACCIDENT]: 'POMI Accident Insurance',
	[POLICY_TYPE.POMI_ACCIDENT_V2]: 'POMI Accident Insurance',
	[POLICY_TYPE.STARR_AD_AND_D]: 'AAC Accidental Death and Dismemberment',
	[POLICY_TYPE.VIGILANCE_V1]: 'Vigilance Occupational Accident',
	[POLICY_TYPE.VIGILANCE_V2]: 'Vigilance Occupational Accident',
};

export {
	ABILITY_TO_PURCHASE,
	APPROVED_STATES,
	COVERED_TYPE,
	CUSTOMER_PROPS_TO_OMIT,
	DATE_FORMAT,
	DOWNLOAD_TYPE,
	DURATION_TYPE,
	LOG_TYPE,
	NO_INTERCOM_SUBDOMAINS,
	NON_STANDARD_VIGILANCE_STATES,
	NON_STANDARD_TICKET_STATES,
	OFFERING_LABEL_MAP,
	PAYMENT_GATEWAY,
	PAYMENT_LOG_TYPE,
	PAYMENT_TYPE,
	POLICY_TYPE,
	SPECIAL_STATES,
	STATE_REQUIRED_VALUES,
	TRANSACTION_LOG_TYPE,
	WHO_TYPE,
};
